import React from "react";
import { packageStates, useTransportV2 } from "../context/TransportV2Context";
import { useLang } from "../i18n";

export default function PackageNavigator() {
  const { state, dispatch } = useTransportV2();
  const { t } = useLang();
  if ((state.selectedPackages || []).length < 2) return null;
  return <nav className="batch-nav" aria-label={t("batch.navigation")}>
    <p className="tiny muted">{t("batch.navigationHint")}</p>
    <div className="batch-nav-items">
      {packageStates(state).map((draft, index) => <button key={draft.pkgId} type="button"
        className={`btn btn-sec batch-nav-item${draft.pkgId === state.pkgId ? " is-active" : ""}`}
        aria-current={draft.pkgId === state.pkgId ? "step" : undefined}
        disabled={!!state.batch || !!state.batchRequest}
        onClick={() => dispatch({ type: "ACTIVATE_PACKAGE", payload: { id: draft.pkgId } })}>
        <span>{index + 1}. {draft.pkgName || draft.pkgId}</span>
        {draft.pkgName && draft.pkgName !== draft.pkgId && <span className="tiny muted">{draft.pkgId}</span>}
        <span className="tiny muted" role="status">{t(draft.precheckState === "running" ? "batch.compareLoading"
          : ["idle", "queued"].includes(draft.precheckState) ? "batch.compareQueued"
          : ["error", "partial"].includes(draft.precheckState) ? "batch.compareFailed"
          : draft.packagePrepared ? "batch.prepared" : "batch.open")}</span>
      </button>)}
    </div>
  </nav>;
}
